export class Backup {
  readonly dir: string;
  readonly time: number;
  readonly name: string | null;
  readonly type: number;
  readonly databaseMain: boolean;
  readonly databasePrice: boolean;
  readonly finished: boolean | null;

  constructor(
    dir: string,
    time: number,
    name: string | null,
    type: number,
    databaseMain: boolean,
    databasePrice: boolean,
    finished: boolean | null,
  ) {
    this.dir = dir;
    this.time = time;
    this.name = name;
    this.type = type;
    this.databaseMain = databaseMain;
    this.databasePrice = databasePrice;
    this.finished = finished;
  }

  static fromRaw(raw: any): Backup {
    return new Backup(
      String(raw.dir),
      Number(raw.time),
      raw.name ?? null,
      Number(raw.type),
      Boolean(raw.databaseMain),
      Boolean(raw.databasePrice),
      raw.finished != null ? Boolean(raw.finished) : null,
    );
  }

  clone(): Backup {
    return new Backup(
      this.dir,
      this.time,
      this.name,
      this.type,
      this.databaseMain,
      this.databasePrice,
      this.finished,
    );
  }

  toPayload(): any {
    const payload: any = {
      dir: this.dir,
      time: this.time,
      type: this.type,
      databaseMain: this.databaseMain,
      databasePrice: this.databasePrice,
    };
    if (this.name !== null) {
      payload.name = this.name;
    }
    if (this.finished !== null) {
      payload.finished = this.finished;
    }
    return payload;
  }
}
